const Anchor = (($) => {
  class Anchor {
    constructor() {
      this.$window = $(window);
      this.$document = $(document);
      this.$body = $("body");
      this.$header = this.$body.find('header:first-of-type');
    }

    updateWpAdminBarHeight() {
      const headerHeight = this.$header.outerHeight(true) || 0;
      document.documentElement.style.setProperty('--header-bar-height', `${headerHeight}px`);
    }

    setEventBindings() {
      this.$window.on("load resize scroll", this.updateWpAdminBarHeight.bind(this));
      this.$document.on("click", "a[href^='#']", this.scrollToAnchor.bind(this));
    }

    scrollToAnchor(event) {
      event.preventDefault();
      const targetId = $(event.currentTarget).attr('href');
      const $target = $(targetId);
      if ($target.length) {
        const targetOffset = $target.offset().top - this.$header.outerHeight(true);
        $('html, body').animate({
          scrollTop: targetOffset
        }, 600); // Adjust the duration (600ms here) to your liking
      }
    }

    init() {
      this.setEventBindings();
      this.updateWpAdminBarHeight(); // Initial update for the header height
    }
  }

  return {
    init() {
      const module = new Anchor();
      module.init();
    },
  };
})(window.jQuery);

// Initialize the module
(($) => {
  Anchor.init();
})(window.jQuery);
